import React from 'react';
import { Link } from 'react-router-dom';
import { SectionCard } from '../../layout/memberPrimitives';
import type { PersonalizedMelioIntelligenceItem } from '../../../types/melioIntelligence';

/**
 * Up to three intelligence stories, each carrying why the member is seeing it.
 *
 * Never padded to three. Fewer real cards is better than filler, and an empty
 * "new insights" heading over nothing is worse than no section.
 */
export default function IntelligenceCards({
  items,
}: {
  items: PersonalizedMelioIntelligenceItem[];
}) {
  if (items.length === 0) return null;

  return (
    <SectionCard
      eyebrow="Melio Intelligence"
      title="Reading for you"
      rightSlot={
        <Link to="/intelligence" className="text-xs underline" style={{ color: 'var(--melio-text-muted)' }}>
          All stories →
        </Link>
      }
    >
      <ul className="grid grid-cols-1 md:grid-cols-3 gap-3 list-none p-0 m-0">
        {items.slice(0, 3).map((item) => (
          <li
            key={item.id || item.slug}
            className="rounded-2xl border p-4 flex flex-col"
            style={{ borderColor: 'var(--melio-border)', backgroundColor: 'var(--melio-cream-warm)' }}
          >
            <h3
              className="text-base font-normal leading-snug mb-2"
              style={{ fontFamily: "var(--melio-quote)", color: 'var(--melio-ink)' }}
            >
              {item.title}
            </h3>
            <p className="text-xs leading-relaxed flex-1" style={{ color: 'var(--melio-text-muted)' }}>
              {item.melioSummary}
            </p>
            {item.personalizationReason && (
              <p
                className="text-[10px] mt-3 pt-2"
                style={{ color: 'var(--melio-sea-deep)', borderTop: '1px solid var(--melio-border)' }}
              >
                Why you&apos;re seeing this: {item.personalizationReason}
              </p>
            )}
          </li>
        ))}
      </ul>
    </SectionCard>
  );
}
